import { useEffect } from 'react';

const PREHYDRATION_ATTR = 'data-prehydration';

/**
 * Removes the `data-prehydration` attribute after the browser paints,
 * as a safety cleanup for cases where no menu item is hovered during hydration
 * (so `updateDropdownDomStyles` never runs and never removes it).
 *
 * When an item IS hovered during hydration, `updateDropdownDomStyles` removes
 * the attribute synchronously during the layout phase of the re-render caused
 * by `showDropdownImmediate()`. That guarantees positioning and attribute removal
 * happen in a single paint — preventing a visible shift. This hook then fires
 * after paint and finds the attribute already gone, so it is a no-op.
 *
 * Using plain `useEffect` (not rAF) is intentional: the double-rAF delay is no
 * longer needed because `updateDropdownDomStyles` handles the timing-critical
 * hovered case directly.
 */
export const usePreHydrationCleanup = (
  rootRef: React.RefObject<HTMLElement | null>,
) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root?.hasAttribute(PREHYDRATION_ATTR)) {
      return;
    }

    root.removeAttribute(PREHYDRATION_ATTR);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
